import moment from 'moment';
var NotosService = /** @class */ (function () {
    function NotosService() {
    }
    NotosService.checkFormValidityFields = function (field, dateIsValid, formIsValid) {
        var validByPattern = true;
        var dateCheck = field.value instanceof Date;
        if (!dateCheck && field.validation.pattern && (field.value.toString().trim() !== '' || field.value !== null)) {
            // Testing the value of the input if it has a regex pattern
            validByPattern = field.validation.pattern.test(field.value);
        }
        else if (dateCheck) {
            if (field.validation.futureDateValidation) {
                dateIsValid = NotosService.checkForFutureDate(field.value);
            }
        }
        return field.valid && formIsValid && validByPattern && dateIsValid;
    };
    NotosService.checkForFutureDate = function (dateTime) {
        // @ts-ignore
        var currentTime = moment();
        // @ts-ignore
        var datePickerTime = moment(dateTime);
        // @ts-ignore
        return !moment(datePickerTime).isAfter(currentTime);
    };
    NotosService.checkForDateBefore = function (current, other) {
        var currentTime = moment(current);
        var otherTime = moment(other);
        return currentTime.isAfter(otherTime);
    };
    // Default time formats
    NotosService.datepickerFormat = 'mm/dd/y'; // Use for datepicker only
    NotosService.dateMomentFormat = 'DD.MM.YYYY';
    NotosService.dateFormatAmCharts = 'MM/dd/YY';
    NotosService.timeMomentFormatSeconds = 'hh:mm:ss a';
    NotosService.timeMomentFormatMinutes = 'hh:mm a';
    NotosService.nameValidationPattern = /^([a-zA-Z0-9])[a-zA-Z0-9 ',. -]+[a-zA-Z0-9]$/;
    NotosService.linkPattern = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
    NotosService.DISPLAY_TYPE_ML = 'ml';
    NotosService.DISPLAY_TYPE_GR = 'gr';
    NotosService.DISPLAY_TYPE_COLOR = 'color';
    NotosService.CURRENCY = 'лв.';
    NotosService.EURO_CURRENCY = '€';
    NotosService.DEFAULT_PRICE = '0.00';
    NotosService.MAX_PRODUCT_VARIANTS = 10000;
    NotosService.MAX_PRODUCT_THUMB_COLOR_VARIANTS = 17;
    NotosService.MAX_PRODUCT_PAGE_COLOR_VARIANTS = 11;
    NotosService.MAX_PRODUCT_THUMB_DOSE_VARIANTS = 3;
    NotosService.HOME_SUGGESTION_OFFERS = 'HOME_SUGGESTION_OFFERS';
    NotosService.HOME_SPECIAL_OFFERS = 'HOME_SPECIAL_OFFERS';
    NotosService.ADDED_TO_CART_DIALOG_SHOWN_TIME = 5000;
    NotosService.USER_STATUS_NORMAL = 'normal';
    NotosService.USER_STATUS_GOLD = 'gold';
    NotosService.USER_STATUS_GUEST = 'guest';
    NotosService.formatDeliveryTypes = function (type) {
        var formattedType = '';
        switch (type) {
            case 'speedy':
                formattedType = 'Speedy';
                break;
            case 'econt':
                formattedType = 'Econt';
                break;
            case 'on_site':
                formattedType = 'На място';
                break;
            case 'speedy_office':
                formattedType = 'Speedy Офис';
                break;
        }
        return formattedType;
    };
    NotosService.formatPromoCodeTypes = function (type) {
        var formattedType = '';
        switch (type) {
            case 'percent':
                formattedType = 'Процент';
                break;
            case 'amount':
                formattedType = 'Стойност';
                break;
            default:
                formattedType = '';
                break;
        }
        return formattedType;
    };
    NotosService.formatDisplayTypes = function (type) {
        var formattedType = '';
        switch (type) {
            case 'color':
                formattedType = 'Цвят';
                break;
            case 'gr':
                formattedType = 'Грамаж';
                break;
            case 'ml':
                formattedType = 'Количество';
                break;
            default:
                formattedType = 'Цвят';
                break;
        }
        return formattedType;
    };
    NotosService.formatStatuses = function (status) {
        var formattedStatus = '';
        switch (status) {
            case 'draft':
                formattedStatus = 'Чернова';
                break;
            case 'published':
                formattedStatus = 'Публикуван';
                break;
            default:
                formattedStatus = '';
                break;
        }
        return formattedStatus;
    };
    NotosService.formatStock = function (status) {
        var formattedStatus = '';
        switch (status) {
            case 'in_stock':
                formattedStatus = 'Наличен';
                break;
            case 'out_of_stock':
                formattedStatus = 'Не е наличен';
                break;
            default:
                formattedStatus = '';
                break;
        }
        return formattedStatus;
    };
    NotosService.formatFilterTypes = function (filterType) {
        var formattedFilterType = '';
        switch (filterType) {
            case 'commercial_status':
                formattedFilterType = 'Комерсиален статус';
                break;
            case 'gender':
                formattedFilterType = 'Пол';
                break;
            case 'product_type':
                formattedFilterType = 'Тип продукт';
                break;
            case 'texture':
                formattedFilterType = 'Текстура';
                break;
            case 'completion':
                formattedFilterType = 'Завършеност';
                break;
            case 'color_range':
                formattedFilterType = 'Цветови диапазон';
                break;
            case 'coverage':
                formattedFilterType = 'Покритие';
                break;
            case 'undertone':
                formattedFilterType = 'Оттенък';
                break;
            case 'skin_type':
                formattedFilterType = 'Тип кожа';
                break;
            case 'aroma':
                formattedFilterType = 'Аромат';
                break;
            case 'effect':
                formattedFilterType = 'Ефект';
                break;
            case 'benefits':
                formattedFilterType = 'Ползи';
                break;
            case 'treatment_area':
                formattedFilterType = 'Зона за нанасяне';
                break;
            case 'eyes_type':
                formattedFilterType = 'Тип продукт';
                break;
            default:
                formattedFilterType = '';
                break;
        }
        return formattedFilterType;
    };
    NotosService.formatAromaticNoteTypes = function (aromaticNoteType) {
        var formattedAromaticNoteType = '';
        switch (aromaticNoteType) {
            case 'top':
                formattedAromaticNoteType = 'Връхни';
                break;
            case 'medium':
                formattedAromaticNoteType = 'Средни';
                break;
            case 'basic':
                formattedAromaticNoteType = 'Базови';
                break;
            default:
                formattedAromaticNoteType = '';
                break;
        }
        return formattedAromaticNoteType;
    };
    NotosService.checkFieldValidity = function (value, rules, eventType, form) {
        var isValid = true;
        if (value != null &&
            typeof value !== 'undefined' &&
            !(value instanceof File || value instanceof Date || Array.isArray(value))) {
            if (rules.required && (eventType === 'onChange' || eventType === 'onBlur')) {
                isValid = value.toString().trim() !== '' && isValid;
            }
            if (rules.pattern && value.trim() !== '' && eventType === 'onBlur') {
                isValid = rules.pattern.test(value) && isValid;
            }
        }
        else if (value != null && typeof value !== 'undefined' && value instanceof Date) {
            if (rules.futureDateValidation) {
                isValid = NotosService.checkForFutureDate(value);
            }
            if (rules.dateBefore) {
                var other = form[rules.dateBefore];
                isValid = other && other.value ? NotosService.checkForDateBefore(value, other.value) : false;
            }
        }
        else if (value != null && typeof value !== 'undefined' && Array.isArray(value)) {
            if (rules.required) {
                isValid = value.length > 0 && isValid;
            }
        }
        else if (!value && rules.required) {
            isValid = false;
        }
        return isValid;
    };
    NotosService.checkFormValidity = function (formFields) {
        var formIsValid = true;
        var dateIsValid = true;
        for (var inputIdentifier in formFields) {
            if (formFields[inputIdentifier].valid !== undefined && formFields[inputIdentifier].valid !== false) {
                formIsValid = NotosService.checkFormValidityFields(formFields[inputIdentifier], dateIsValid, formIsValid);
            }
            else if (Array.isArray(formFields[inputIdentifier])) {
                for (var _i = 0, _a = formFields[inputIdentifier]; _i < _a.length; _i++) {
                    var fieldset = _a[_i];
                    if (fieldset) {
                        for (var _b = 0, fieldset_1 = fieldset; _b < fieldset_1.length; _b++) {
                            var item = fieldset_1[_b];
                            if (item.valid !== undefined) {
                                formIsValid = NotosService.checkFormValidityFields(item, dateIsValid, formIsValid);
                            }
                        }
                    }
                }
            }
        }
        return formIsValid;
    };
    return NotosService;
}());
export default NotosService;



//////////////////
// WEBPACK FOOTER
// ./src/classes/notos.service.ts
// module id = 10
// module chunks = 0